<section class="about-cta-section" *ngIf="section">
  <div class="about-cta-inner">
    <div class="about-cta-content">
      <h2>
        <span>{{ section.titleLineOne }}</span>
        <span>{{ section.titleLineTwo }}</span>
      </h2>
      <p>{{ section.subtitle }}</p>
      <a [routerLink]="section.buttonUrl || '/get-started'" class="about-cta-btn">{{ section.buttonLabel }}</a>
      <small *ngIf="section.finePrint">{{ section.finePrint }}</small>
    </div>
  </div>
</section>
